export default "__VITE_ASSET__CIn9hYPI__"